export default state => state.active;



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Description/store/getters.js